export class AppContext {
    static { this.context = {}; }
    static getContext() {
        return AppContext.context;
    }
    static setContext(newContext) {
        AppContext.context = newContext;
    }
    static setCurrentUser(currentUser) {
        AppContext.context.currentUser = currentUser;
    }
    static getCurrentUser() {
        return AppContext.context.currentUser;
    }
    static addToContext(key, value) {
        AppContext.context[key] = value;
    }
    static getFromContext(key) {
        return AppContext.context[key];
    }
    static setBackendUrl(backendUrl) {
        AppContext.context.backendUrl = backendUrl ?? '';
    }
    static getBackendUrl() {
        return AppContext.context?.backendUrl ?? '';
    }
    static setTrackerUrl(trackerUrl) {
        AppContext.context.trackerUrl = trackerUrl;
    }
    static getTrackerUrl() {
        return AppContext.context?.trackerUrl ?? 'https://health.galigeo.com';
    }
}
